import React from "react";
import withSvgIcon from "~/hocs/with-svg-icon";

export const SamplingNematodeIcon = withSvgIcon(
    <g>
        <path
            d={
                "M74.3,37.6c-1.9.8-3.8,1.6-5.7,2.4-4.1,1.7-8.3,3.5-12.6,5.1-3.2,1.2-5.8,2-8.4,2.5h-.2c-2.8.5-6.7,1.2-9.5,0-2-.8-3.5-2.7-4.4-5.2-1-3-.9-6.5.4-8.8,2.4-4.3,7.9-4.8,12.3-5.1,1.1,0,2.1-.2,3-.3,5.5-.8,11.1-2,14.3-5.4,3.6-3.9,2.8-10.3,2.2-12.9-.9-4.3-4.6-6.8-9.3-6.2-3.2.4-6.2,2.1-9.2,3.7-1.9,1.1-3.8,2.1-5.8,2.9C29.3,14.6,14.9,11.1,2.1.3,1.4-.3.6.1.3.5c-.2.3-.5.8,0,1.4,7.3,6.1,18.7,13.2,32.1,12.5,5.3-.3,10.6-2,16.4-5.2.4-.2.7-.4,1.1-.6,2.3-1.3,4.9-2.8,7.7-2.8h.1c3.6,0,5.7,2.3,6,6.6.2,2.8.3,5.9-1.5,8.3-1.9,2.4-5.3,3.3-8.1,4h-.3c-2.3.7-4.8.9-7.1,1.2-3.3.3-6.8.7-9.8,2-3.7,1.6-6.1,5.3-6.3,9.9-.3,4.8,1.8,9.2,5.4,11.4,2.3,1.5,5.4,1.4,8.1,1.2,3.3-.3,6.6-.9,9.7-2,5-1.7,10-3.8,14.8-5.9,2.1-.9,4.1-1.8,6.2-2.6.9-.4.9-1.3.7-1.9-.2-.4-.5-.8-1.2-.5h0Z"
            }
        />
    </g>,
    "0 0 75.6 50.4",
    "event-label-icon"
);
